import React, { useEffect, useState,Fragment } from 'react';
import { Box } from '@material-ui/core';
import { vehicleNumberDisplay } from '../../../utils/utils';
const VehicleNumberFormat = (props)=>{
    const { 
       value,
       size,
       color
    } = props;
    let formatted = value?vehicleNumberDisplay(value):null
    let arrayValue = formatted?formatted.split(" "):[]
    return <Box display={'flex'} alignItems={'center'}>
            {arrayValue&&arrayValue.map((val,index)=>{
                let styleCss={
                    fontSize:size?size:10,
                    fontWeight:300,
                    color:index==arrayValue.length-1?'#2c5de5':color?color:'#0b1323',
                    marginLeft:index==0?0:2
                }
                return <span style={styleCss}>{val}</span>
            })}
    </Box>;
}
export default VehicleNumberFormat;